import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ISelfBillingAgreement } from '../interfaces/self-billing-agreement';
import { ISelfBillingAgreementFilter } from '../interfaces/self-billing-agreement-filter';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { EditService } from './edit.service';

@Injectable({ providedIn: 'root' })
export class SelfBillingAgreementService extends EditService<
  ISelfBillingAgreement,
  ISelfBillingAgreementFilter
> {
  url = '/api/selfbilling';
  entityTitle = 'Self-billing Agreement';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  commitSelfBillingStatus(isAgreed): Promise<any> {
    return this.http
      .post(`${this.url}/commitSelfBillingStatus?isAgreed=${isAgreed}`, null)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getSelfBillingStatus(): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}/getSelfBillingStatus`),
      this.handlersFactory.getDefault(),
    );
  }

  public needRedirectToSelfBilling(): Promise<any> {
    return this.http
      .get(`${this.url}/needRedirectToSelfBilling`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public getActualSelfBillingAgreement(): Promise<ISelfBillingAgreement> {
    return this.handleRequest(
      this.http.get<any>(`${this.url}/getActualSelfBillingAgreement`),
      this.handlersFactory.getDefault(),
    );
  }

  // createAgreement(supplierId: number): Promise<any> {
  //     return this.handleRequest(
  //         this.http.post(`${this.url}/create-agreement/${supplierId}`, null),
  //         this.handlersFactory.getForCreate(this.entityTitle))
  // }
}
